/* eslint-disable no-unused-vars */
enum EquipmentCategory {
  HEAD = 0,
  CHEST = 1,
  ARMS = 2,
  WAIST = 3,
  LEGS = 4,
  CHARM = 5,
  WEAPON = 6,
}

export default EquipmentCategory
